
import React from "react";

interface SectionProps {
  id?: string;
  title: string;
  text: string | string[];     
  imageSrc?: string;
  invert?: boolean;
  button?: string;
}

const LandingSectionKenya: React.FC<SectionProps> = ({
  id,
  title,
  text,
  imageSrc,
  invert = false,
  button,
}) => {
  /* ② Normalise to an array of paragraph strings */
  const paragraphs: string[] = Array.isArray(text)
    ? text
    : text.split(/\r?\n\r?\n/);     // split on one or more blank lines

  return (
    <div className="sm:py-8 px-6 md:px-22 lg:px-24">
      <section
        id={id}
        className={`flex flex-col md:flex-row ${
          invert ? "md:flex-row-reverse" : ""
        } items-center gap-8 py-16`}
      >
        {imageSrc && (
          <img
            src={imageSrc}
            alt={title}
            className="w-full md:w-1/2 rounded-2xl shadow-lg"
          />
        )}

        <div className="w-full md:w-1/2">
          <h2 className="text-xl lg:text-xl font-semibold font-akshar mb-2 sm:mb-4">
            {title}
          </h2>

          {/* ③ Render each paragraph in its own <p> */}
          {paragraphs.map((para, idx) => (
            <p
              key={idx}
              className="lg:text-base font-poppins sm:text-base md:text-lg text-gray-700 text-justify mb-4"
            >
              {para}
            </p>
          ))}

          {button && (
            <button className="font-anekbangla inline-block py-2 px-4 mt-3 mb-3 border-2 uppercase border-black text-black hover:bg-gray-700 hover:text-white transition rounded-md font-semibold">
              {button}
            </button>
          )}
        </div>
      </section>
    </div>
  );
};

export default LandingSectionKenya;
